/* eslint-disable consistent-return */
import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";
import { ALL_CUSTOMERS_OPTION } from "components/Screens/Timeoff/TimeoffAdmin/Constants";

export const getEmployeeTimeOffDetails = async (payload) => {
  try {
    const { employeeId, startDate, endDate, leaveTypeId, customerId, anniversaryBasedTimeOff } = payload;
    const params = new URLSearchParams();
    params.append("employeeId", employeeId || "");
    // Omitted (not empty) dates are how "All time" reaches the API — the admin
    // leaveRequests query only applies a date where-clause when both are present.
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    params.append("leaveTypeId", leaveTypeId || "");
    if (customerId) params.append("customerId", customerId);

    const response = await getRequest(
      `${baseUrl}${anniversaryBasedTimeOff ? "/v2" : ""}/admin/leaveRequests?${params.toString()}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeCustomerOptions = async (employeeId) => {
  try {
    const response = await getRequest(`${baseUrl}/employee/${employeeId}/employmentHistory`, true);
    const history = Array.isArray(response?.payload) ? response.payload : [];
    const seenCustomerIds = new Set();
    const options = [];

    // History is returned newest-assignment-first; keep that order and the first
    // occurrence of each customer the employee has worked with.
    history.forEach((assignment) => {
      const key = assignment?.customerId || assignment?.customer?.customerId;
      const label = assignment?.customer?.companyName;
      if (!key || !label || seenCustomerIds.has(key)) return;
      seenCustomerIds.add(key);
      options.push({ key, label });
    });

    return [ALL_CUSTOMERS_OPTION, ...options];
  } catch (error) {
    console.log(error);
    return [ALL_CUSTOMERS_OPTION];
  }
};

export const getEmployeeLeavesDataForAdmin = async (employeeId, anniversaryBasedTimeOff) => {
  try {
    const response = await getRequest(
      `${baseUrl}${anniversaryBasedTimeOff ? "/v2" : ""}/admin/leave_types/${employeeId}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const addEmployeeNewLeaveRequest = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/v3/employee/leave`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

// PRD-442: V4 admin leave creation with future cycle support
export const addEmployeeNewLeaveRequestV4 = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/v4/admin/createLeave`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeLeavesDataForAdminV4 = async (employeeId) => {
  try {
    const response = await getRequest(`${baseUrl}/v4/employee/${employeeId}/leave_types`, true);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getTotalLeaveCountV2 = async (
  employeeId,
  leaveId,
  startDate,
  endDate,
  excludeRequestId = null,
  swapDates = null
) => {
  try {
    let url = `${baseUrl}/v2/admin/${employeeId}/count_leaves/${leaveId}?dateFrom=${startDate}&dateTo=${endDate}`;
    if (excludeRequestId) {
      url += `&excludeRequestId=${excludeRequestId}`;
    }
    // Swapped leave types are rejected server-side without these, so send them whenever
    // the caller has a swap day selected.
    if (swapDates?.startDate && swapDates?.endDate) {
      url += `&swapDateFrom=${swapDates.startDate}&swapDateTo=${swapDates.endDate}`;
    }
    const response = await getRequest(url);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeDocuments = async (request) => {
  try {
    const response = await getRequest(`${baseUrl}/${request}`, true);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const addSwappedLeaves = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/admin/swapped_leaves`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeesLeaveAndHolidays = async (employeeId, startDate, endDate) => {
  try {
    const response = await getRequest(
      `${baseUrl}/admin/employee/${employeeId}/leave_holidays?startDate=${startDate}&endDate=${endDate}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

// PRD-3255: read only balances from an unassigned talent's most recent assignment
export const getLastAssignmentLeaveBalance = async (employeeId) => {
  try {
    const response = await getRequest(`${baseUrl}/admin/employee/${employeeId}/last_assignment_leave_balance`, true);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};
